const defaultStore = {
  dishTemplate: '',
};

export default (state = defaultStore, action) => {
  switch (action.type) {
    case 'GET_DISH_TEMPLATE':
      return {
        ...state,
        dishTemplate: {
          recepie: {
            products: [],
            text: '',
          },
          tags: [],
          weight: {},
        },
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/dishTemplate.js